var _rect, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 19,
    rx: 1.5,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 10,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 17.5,
    r: 6,
    fill: "white",
    stroke: "#343434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.125H10.9362L13.0325 15.0287L12.5 14.5L9.5 17.5L12.5 20.5L13.0287 19.9713L10.9362 17.875H15.5V17.125Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.710747e22dd118550b946132b1aa824e.svg";
export { ForwardRef as ReactComponent };